import { render, staticRenderFns } from "./FoodList.vue?vue&type=template&id=548f4718&scoped=true"
import script from "./FoodList.vue?vue&type=script&lang=js"
export * from "./FoodList.vue?vue&type=script&lang=js"
import style0 from "./FoodList.vue?vue&type=style&index=0&id=548f4718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548f4718",
  null
  
)

export default component.exports